import React from 'react';
import { motion } from 'framer-motion';
const primariaModules = [{
  n: 'TOMO 1',
  title: 'Lenguaje Visual I',
  items: ['El Punto', 'La Línea', 'El Plano', 'La Forma', 'La Textura']
}, {
  n: 'TOMO 2',
  title: 'Lenguaje Visual II',
  items: ['El Color', 'El Valor', 'El Espacio', 'La Composición', 'El Movimiento']
}, {
  n: 'TOMO 3',
  title: 'Técnicas y Materiales',
  items: ['El Dibujo', 'La Pintura', 'El Collage', 'La Escultura', 'El Grabado']
}, {
  n: 'TOMO 4',
  title: 'Historia del Arte',
  items: ['Arte Prehistórico', 'Arte Antiguo', 'Renacimiento', 'Arte Moderno', 'Arte Contemporáneo']
}, {
  n: 'TOMO 5',
  title: 'Arte y Cultura',
  items: ['Arte Argentino', 'Arte Latinoamericano', 'Arte Popular', 'Arte Indígena', 'Arte del Mundo']
}, {
  n: 'TOMO 6',
  title: 'Proyectos y Expresión',
  items: ['Historieta', 'Mural', 'Diseño Gráfico', 'Fotografía', 'Portfolio']
}];
const secundariaModules = [{
  n: 'TOMO 1',
  title: 'Lenguaje Visual y Composición',
  items: ['Elementos visuales y principios de composición para nivel secundario']
}, {
  n: 'TOMO 2',
  title: 'Color y Composición',
  items: ['Teoría del color, armonías, valor y organización del espacio']
}, {
  n: 'TOMO 3',
  title: 'Dibujo y Técnicas',
  items: ['Dibujo observacional, técnicas mixtas y proceso creativo']
}, {
  n: 'TOMO 4',
  title: 'Diseño, Comunicación Visual y Arte Contemporáneo',
  items: ['Diseño gráfico, tipografía, identidad, Pop Art, Street Art, Arte Conceptual']
}, {
  n: 'TOMO 5',
  title: 'Historia del Arte Universal',
  items: ['De la Prehistoria al Arte Contemporáneo. Artistas, movimientos y análisis de obras.']
}, {
  n: 'TOMO 6',
  title: 'Producción Artística Profesional',
  items: ['Portafolio, curaduría, arte digital, IA aplicada al arte y proyecto final']
}];
export function ModulesGrid() {
  return <section className="py-24 lg:py-32 bg-paper-alt" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-152">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-50 text-terra-600 font-medium text-xs uppercase tracking-widest mb-6 border border-terra-100" data-id="element-153">
            2 MEGAPACKS · 12 TOMOS COMPLETOS
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-154">
            Lo que recibís <span className="text-brand-500" data-id="element-155">hoy mismo</span>
          </h2>
          <p className="text-lg text-ink-600 font-normal" data-id="element-156">
            Al comprar, recibís el MegaPack Primaria Y el MegaPack Secundaria —
            ambos completos, en una sola compra.
          </p>
        </motion.div>

        <div className="mb-20" data-id="element-157">
          <div className="mb-8 inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-500 text-white font-medium text-xs uppercase tracking-widest" data-id="element-158">
            PRIMARIA
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-159">
            {primariaModules.map((mod, i) => <motion.div key={`primaria-${i}`} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08,
            duration: 0.8,
            ease: 'easeOut'
          }} className="group relative bg-paper-card rounded-[20px] p-8 lg:p-10 shadow-soft border border-paper-border transition-shadow hover:shadow-card overflow-hidden" data-id="element-160">
                <div className="relative z-10" data-id="element-161">
                  <div className="text-xs font-medium tracking-[0.2em] text-terra-600 mb-6 uppercase" data-id="element-162">
                    {mod.n}
                  </div>
                  <h3 className="font-serif font-medium text-2xl text-ink-800 mb-5 leading-tight" data-id="element-163">
                    {mod.title}
                  </h3>
                  <ul className="space-y-3" data-id="element-164">
                    {mod.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-sm text-ink-600 font-normal" data-id="element-165">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-400 shrink-0" data-id="element-166" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div data-id="element-167">
          <div className="mb-8 inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-500 text-white font-medium text-xs uppercase tracking-widest" data-id="element-168">
            SECUNDARIA
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-169">
            {secundariaModules.map((mod, i) => <motion.div key={`secundaria-${i}`} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08,
            duration: 0.8,
            ease: 'easeOut'
          }} className="group relative bg-paper-card rounded-[20px] p-8 lg:p-10 shadow-soft border border-paper-border transition-shadow hover:shadow-card overflow-hidden" data-id="element-170">
                <div className="relative z-10" data-id="element-171">
                  <div className="text-xs font-medium tracking-[0.2em] text-brand-600 mb-6 uppercase" data-id="element-172">
                    {mod.n}
                  </div>
                  <h3 className="font-serif font-medium text-2xl text-ink-800 mb-5 leading-tight" data-id="element-173">
                    {mod.title}
                  </h3>
                  <ul className="space-y-3" data-id="element-174">
                    {mod.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-sm text-ink-600 font-normal" data-id="element-175">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-400 shrink-0" data-id="element-176" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}